import { render, staticRenderFns } from "./RidersWidgetHolder.vue?vue&type=template&id=79d3a5db"
import script from "./RidersWidgetHolder.vue?vue&type=script&lang=js"
export * from "./RidersWidgetHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RidersWidgetHolder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports